import React from 'react';
import CardUser from '../CardUser/CardUser';
import styles from './CardUserContainer.module.css';

const columns = [
  'Foto', 'Nombre', 'DNI', 'Email', 'Teléfono', 'Cuota paga', 'Vencimiento'
];

const CardUserContainer = ({ users }) => {
  if (!users.length) return <p>No hay socios para mostrar.</p>;
  return (
    <div className={styles.tableContainer}>
      <div className={styles.headerRow}>
        {columns.map(col => (
          <div key={col} className={styles.headerCell}>{col}</div>
        ))}
      </div>
      {users.map(user => (
        <CardUser key={user.id} user={user} />
      ))}
    </div>
  );
};

export default CardUserContainer;